import { render, staticRenderFns } from "./FundsGift.vue?vue&type=template&id=78c45a7b"
import script from "./FundsGift.vue?vue&type=script&lang=js"
export * from "./FundsGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports